import React, {useContext} from 'react'
import { styled } from '@mui/material/styles'
import {range} from 'lodash'

import {TeacherContext} from 'teacher/context'
import SearchPattern from '../search-pattern'
import Group from './Group'
import StudentCount from './StudentCount'

const StyledMonitoringGroups = styled('div')(monitoringGroupStyles)

export default function Groups () {
  const context = useContext(TeacherContext)
  const {groups, translate} = context
  const columnCount = Math.floor(context.sizes.width / 342)
  const missingCount = context.groups.length % columnCount
  return (
    <StyledMonitoringGroups className="monitoring groups">
      <div className="filters">
        <div className="filler" />
        <SearchPattern />
      </div>
      <div className="content">
        <StudentCount groups={groups} translate={translate} />
        <div className="groups">
          {groups.map((group, i) => (<Group key={i} {...group} />))}
          {range(columnCount - missingCount).map((i) => (<div key={i} className="filler" style={{width: 342}}/>))}
        </div>
      </div>
    </StyledMonitoringGroups>)
}

function monitoringGroupStyles() {
  return {
      display: 'flex',
      flexGrow: 1,
      flexDirection: 'column',
      padding: '10px 20px',
      "& .filters": {
        display: 'flex',
        padding: '13px 0 20px 0',
        color: '#a9b1b6',
        '.filler': {
          flexGrow: 1
        }
      },
      "& > .content": {
        overflowY: 'hidden',
        color: '#4e576e',
        flexGrow: 1,
        borderRadius: 3,
        backgroundColor: '#fff',
        border: 'solid 1px #dfdfdf',
        display: 'flex',
        flexDirection: 'column',
        "& > .student-count": {
          borderBottom: 'solid 1px #e7edf0',
          padding: '10px 20px',
          display: 'flex',
          "& .icon": {
            color: '#78a7ff',
            fontSize: '15pt',
          },
          "& .count": {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            textTransform: 'lowercase',
            padding: '0 20px 0 8px',
            borderRight: 'solid 1px #e7edf0'
          }
        },
        "& > .groups": {
          padding: 20,
          display: 'flex',
          overflowY: 'scroll',
          justifyContent: 'space-evenly',
          flexWrap: 'wrap',
          "& .group": {
            borderRadius: 8,
            border: 'solid 1px #ced3e0',
            height: 60,
            width: 300,
            padding: '10px 20px',
            marginBottom: '20px',
            display: 'flex',
            "&:hover": {
              transform: 'scale(1.03)'
            },
            "& .group-link": {
              cursor: 'pointer',
              flexGrow: 1,
              display: 'flex',
              textDecoration: 'none',
              "& .icon-wrapper": {
                backgroundColor: '#fff',
                border: '1px solid #d8e8fb',
                borderRadius: '50%',
                height: 56,
                width: 56,
                padding: 2,
                "& .icon": {
                  height: 20,
                  width: 20,
                  borderRadius: '50%',
                  fontSize: '18pt',
                  display: 'flex',
                  backgroundColor: '#e6f2ff',
                  padding: 18,
                  justifyContent: 'center',
                  color: '#c54ebf'
                },
              },
              "& .label": {
                color: '#4e576e',
                flexGrow: 1,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                paddingLeft: 25,
                "& .name": {
                  fontWeight: 'bold',
                  fontSize: '11pt'
                },
                "& .count": {
                  paddingTop: 1,
                  textTransform: 'lowercase',
                  fontSize: '9.5pt'
                }
              }
            }
          }
        }
      }
    }
  }
